import { Component } from 'san';
import { IScheduleTimesCallback } from 'src/models';

export default class ScheduleTimes extends Component {

    constructor(options: any) {
        super(options);
    }

    initData(): {
        times: number,
        isShow: boolean,
        callback: IScheduleTimesCallback
    } {
        return {
            times: 1,
            isShow: false,
            callback: null
        };
    }

    inited(): void {
        this.watch('times', times => {
            if (!times || +times < 1) {
                times = 1;
            }
            this.data.set('times', Math.floor(+times));
        });
    }

    show(callback: IScheduleTimesCallback) {
        this.data.set('times', 1);
        this.data.set('isShow', true);
        this.data.set('callback', callback)
    }

    submit() {
        const callback = this.data.get('callback');
        const times = this.data.get('times');
        callback(times);
        this.close();
    }

    cancel() {
        this.close();
    }

    close() {
        // 关闭时，不清空数据，而是在show()时重置数据。防止连续调用show()无效
        this.data.set('isShow', false);
    }
}